module.exports = __webpack_public_path__ + "img/LV5.0899e8b7.webp";